export default __webpack_public_path__ + "static/media/swoosh-logo.ff1b8502.png";